import stripTags from "./strip-tags"

const generateIdFromText = (text: string, id: string | number | null = null): string => {
  const sanitizedText: string = text ? stripTags(text).toLowerCase().replace(/[^a-zA-Z ]/g, '').replaceAll(' ', '-') : ''
  return `${sanitizedText}${id ? `-${id}` : ''}`
}

export default generateIdFromText
